import { render, staticRenderFns } from "./AddTicketGatewayInternational.vue?vue&type=template&id=2fa24901"
import script from "./AddTicketGatewayInternational.vue?vue&type=script&lang=js"
export * from "./AddTicketGatewayInternational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports